import styled from 'styled-components';

export const NetworkedTalentName = styled.span<{ isLocked: boolean }>`
  ${({ isLocked }) => isLocked ? 'filter: blur(3px)' : ''};
  font-weight: bold;
`;
